<template>
  <div class="main">
    <div class="nav">
      <ul>
        <li
          :style="
            index == nav.length - 1
              ? currentIndex == index
                ? `background-color:#ff7d48;color:#fff;border-right:none;width:calc((100vw - 0.6rem)/${nav.length})`
                : `border-right:none;width:calc((100vw - 0.6rem)/${nav.length})`
              : currentIndex == index
              ? `background-color:#ff7d48;color:#fff;width:calc((100vw - 0.6rem)/${nav.length})`
              : `width:calc((100vw - 0.6rem)/${nav.length})`
          "
          v-for="(item, index) in nav"
          :key="index"
          @click="changeNews(item, index)"
        >
          {{ item.title }}
        </li>
      </ul>
    </div>
    <div class="content">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import Bus from "@/utils/bus.js";
export default {
  data() {
    return {
      currentIndex: 0,
    };
  },
  props: {
    nav: {
      type: null,
    },
  },
  mounted() {
    this.changeIndex();
    // Bus.$on("changeIndex", e => {
    //   this.changeIndex();
    // });
  },
  methods: {
    changeNews(item, index) {
      this.currentIndex = index;
      this.$router.push({ name: item.url });
    },
    changeIndex() {
      this.nav.forEach((item, index) => {
        if (
          item.url ==
          window.location.hash.substring(2, window.location.hash.length)
        ) {
          this.currentIndex = index;
        }
      });
    },
  },
  components: {},
};
</script>

<style lang="less" scoped>
@color: #ff7234;
.main {
  margin-top: 150px;
  padding-top: 20px;
  padding-bottom: 50px;
  width: 100%;
  background-color: #ebebeb;
  .nav {
    height: 60px;
    width: calc(100vw - 60px);
    margin: 0 auto;
    margin-bottom: 20px;
    background-color: #fff;
    border-radius: 10px;
    overflow: hidden;

    ul {
      display: flex;
      height: 60px;
      justify-content: center;
      li {
        font-size: 30px;
        color: #333;
        height: 60px;
        text-align: center;
        line-height: 60px;
        border-right: 1px solid #cccccc;
        cursor: pointer;
      }
    }
  }
  .content {
    background-color: #ebebeb;
    width: 100%;
    .v-enter {
      opacity: 0;
    }
    .v-enter-active {
      transition: 0.5s;
    }
    .v-enter-to {
      opacity: 1;
    }
    .v-leave {
      opacity: 1;
    }
    .v-leave-to {
      opacity: 0;
    }
    .v-leave-active {
      transition: 0.5s;
    }
  }
}
</style>